import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../services/api";
import { setToastOk } from "../main/mainSlice";

const initialState = {
  jishoWords: undefined,
  jishoWordDetail: undefined,
  currentPage: 1,
  itemsPerPage: 50,
  totalPages: 0,
  query: {},
};

export const fetchJishoWords = createAsyncThunk(
  "jishoWords/fetchJishoWords",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      var query = "";
      Object.keys(data).forEach((key) => {
        if (data[key]) {
          if (query !== "") {
            query += `&`;
          }
          query += `${key}=${data[key]}`;
        }
      });
      const response = await api.get(`/jishoWords/search?${query}`);
      return response.data;
    } catch (error) {
      dispatch(
        setToastOk({
          isOk: false,
          messages: error.response.data,
        }),
      );
      return rejectWithValue(error.response.data);
    }
  },
);

export const fetchJishoWordDetail = createAsyncThunk(
  "jishoWords/fetchJishoWordDetail",
  async ({ _id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`/jishoWords/${_id}`);
      return response.data.data;
    } catch (error) {
      dispatch(
        setToastOk({
          isOk: false,
          messages: error.response.data,
        }),
      );
      return rejectWithValue(error.response.data);
    }
  },
);

export const createJishoWord = createAsyncThunk(
  "jishoWords/createJishoWord",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(`/jishoWords`, payload);
      dispatch(
        setToastOk({
          isOk: true,
          messages: response.data.message,
        }),
      );

      return response.data.data;
    } catch (error) {
      dispatch(
        setToastOk({
          isOk: false,
          messages: error.response.data,
        }),
      );
      return rejectWithValue(error.response.data);
    }
  },
);

export const editJishoWord = createAsyncThunk(
  "jishoWords/editJishoWord",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.patch(`/jishoWords/${payload._id}`, payload);
      dispatch(
        setToastOk({
          isOk: true,
          messages: response.data.message,
        }),
      );

      return response.data;
    } catch (error) {
      dispatch(
        setToastOk({
          isOk: false,
          messages: error.response.data,
        }),
      );
      return rejectWithValue(error.response.data);
    }
  },
);

export const deleteJishoWord = createAsyncThunk(
  "jishoWords/deleteJishoWord",
  async ({ jishoWordsId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.delete(`/jishoWords/${jishoWordsId}`);
      dispatch(
        setToastOk({
          isOk: true,
          messages: response.data.message,
        }),
      );
      return response.data;
    } catch (error) {
      dispatch(
        setToastOk({
          isOk: false,
          messages: error.response.data,
        }),
      );
      return rejectWithValue(error.response.data);
    }
  },
);

export const jishoWordsSlice = createSlice({
  name: "jishoWords",
  initialState,
  reducers: {
    removeJishoWord: (state, action) => {
      state.jishoWordDetail = undefined;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setQuery: (state, action) => {
      state.query = action.payload;
    },
  },
  extraReducers: (jishoWords) => {
    jishoWords
      .addCase(fetchJishoWords.pending, (state) => {})
      .addCase(fetchJishoWords.fulfilled, (state, action) => {
        state.jishoWords = action.payload.data;
        state.totalPages = action.payload.pagination.totalPages;
      })
      .addCase(fetchJishoWords.rejected, (state, action) => {})
      .addCase(fetchJishoWordDetail.pending, (state) => {})
      .addCase(fetchJishoWordDetail.fulfilled, (state, action) => {
        state.jishoWordDetail = action.payload;
      })
      .addCase(fetchJishoWordDetail.rejected, (state, action) => {})
      .addCase(createJishoWord.pending, (state) => {})
      .addCase(createJishoWord.fulfilled, (state, action) => {
        state.jishoWords = state.jishoWords
          ? [action.payload, ...state.jishoWords]
          : [action.payload];
      })
      .addCase(createJishoWord.rejected, (state, action) => {})
      .addCase(editJishoWord.pending, (state) => {})
      .addCase(editJishoWord.fulfilled, (state, action) => {
        const editedJishoWord = action.payload;
        state.jishoWords?.forEach((jishoWord) => {
          if (jishoWord._id === editedJishoWord._id) {
            Object.keys(jishoWord).forEach((key) => {
              jishoWord[key] = editedJishoWord[key];
            });
          }
        });
      })
      .addCase(editJishoWord.rejected, (state, action) => {})
      .addCase(deleteJishoWord.pending, (state) => {})
      .addCase(deleteJishoWord.fulfilled, (state, action) => {
        const deletedId = action.payload._id;
        state.jishoWords = state.jishoWords?.filter(
          (jishoWord) => jishoWord._id !== deletedId,
        );
      })
      .addCase(deleteJishoWord.rejected, (state, action) => {});
  },
});

export const { removeJishoWord, setCurrentPage, setQuery } =
  jishoWordsSlice.actions;

export default jishoWordsSlice.reducer;
